import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import PropTypes from "prop-types";
import { CenteredPanelImpl } from "./centered-panel.styles.es.js";
const propTypes = {
  centerY: PropTypes.bool,
  children: PropTypes.node.isRequired,
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
const defaultProps = {
  centerY: false,
  maxWidth: "max-content",
  minWidth: "min-content"
};
const CenteredPanel = forwardRef(
  ({ centerY, children, maxWidth, minWidth }, ref) => /* @__PURE__ */ jsx(
    CenteredPanelImpl,
    {
      ref,
      $centerY: centerY,
      $maxWidth: maxWidth,
      $minWidth: minWidth,
      children
    }
  )
);
CenteredPanel.propTypes = propTypes;
CenteredPanel.defaultProps = defaultProps;
export {
  CenteredPanel
};
